import * as toast from './toast'

export default {toast}